import { render } from "./SignInButton.vue?vue&type=template&id=09864824"
import script from "./SignInButton.vue?vue&type=script&lang=js"
export * from "./SignInButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__